"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ModeratorKitContainer", {
  enumerable: true,
  get: function get() {
    return _ModeratorKitContainer.default;
  }
});
Object.defineProperty(exports, "ModeratorKitPanel", {
  enumerable: true,
  get: function get() {
    return _ModeratorKitPanel.ModeratorKitPanel;
  }
});
Object.defineProperty(exports, "ModeratorKitPanelHeader", {
  enumerable: true,
  get: function get() {
    return _ModeratorKitPanel.ModeratorKitPanelHeader;
  }
});
Object.defineProperty(exports, "ModeratorKitSchema", {
  enumerable: true,
  get: function get() {
    return _codeOfConduct.ModeratorKitSchema;
  }
});
exports.default = void 0;

var _ModeratorKitContainer = _interopRequireDefault(require("./ModeratorKitContainer"));

var _ModeratorKitPanel = require("./ModeratorKitPanel");

var _codeOfConduct = require("./codeOfConduct.service");

// Export components and types using named exports as per the barrel pattern best practices
// For backward compatibility
var _default = _ModeratorKitContainer.default;
exports.default = _default;